import type { VivoPlotProps } from "@/components/VivoPlots/types";

const RENDERED_AXIS_SORT_VERSION = 2;

export const getBarplotSortAxes = (
  categoricalPosition: "left" | "bottom",
  sortSemanticsVersion?: number,
) => {
  if (sortSemanticsVersion !== RENDERED_AXIS_SORT_VERSION) {
    return { categorySortAxis: "x", countSortAxis: "y" } as const;
  }

  return categoricalPosition === "left"
    ? ({ categorySortAxis: "y", countSortAxis: "x" } as const)
    : ({ categorySortAxis: "x", countSortAxis: "y" } as const);
};

export const getEditorBarplotSortBy = (
  initialPlotSetup?: VivoPlotProps | null,
): "x" | "y" => {
  const sortBy = initialPlotSetup?.config?.xSortBy || "x";
  const isLegacyHorizontalBarplot =
    initialPlotSetup?.type === "barplot" &&
    initialPlotSetup?.config?.orientation === "horizontal" &&
    initialPlotSetup?.config?.barplotSortSemanticsVersion !==
      RENDERED_AXIS_SORT_VERSION;

  if (!isLegacyHorizontalBarplot) return sortBy;
  return sortBy === "x" ? "y" : "x";
};
